<script>
import {datePickerLanguage, vCalendarSq} from '../../../services/CalendarLocaleSQ';
import moment from "moment";

export default {
    name: "PlanForm",
    props: {
        eventType: String,
        showModal: Boolean,
        plannerId: Number,
        values: Object,
        allowNew: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            lang: document.documentElement.lang,
            masks: vCalendarSq.masks,
            openModal: this.showModal,
            title: [],
            initialModel: {
                id: null,
                title: null,
                description: null,
                origin: null,
                start: null,
                end: null,
                meal_id: null,
                planner_id: this.plannerId,
                recurring: null,
                recurring_till: null,
                members: null,
            },
            model: {
                start: null,
                end: null,
            },
            errors: [],
            errorFields: {
                title: null,
                start: null,
                end: null,
                description: null,
            },
            selectAttribute: {
                highlight: {
                    class: 'bg-light-primary',
                    contentClass: 'text-primary',
                }
            },
        }
    },
    watch: {
        title: function (val) {
            const setting = val[0];
            this.model.option_id = setting?.id;
            this.model.title = setting?.label;

            // Set the start time to the selected setting value time if it is a valid time format
            const settingValue = setting?.data?.value;
            if(settingValue && this.isValidTimeFormat(settingValue)) {
                this.model.start = moment(this.model.start, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY') + ' ' + settingValue
            } else {
                if(!this.model.id || this.model.description === '') {
                    this.model.description = settingValue;
                }
            }
        },
    },
    methods: {
        language: datePickerLanguage,
        open(model) {
            this.clear();

            model.start = model.id ? moment(model.origin).format('DD-MM-YYYY HH:mm:ss') :
                moment(model.start ?? new Date()).format('DD-MM-YYYY HH:mm:ss');

            if(model.options) {
                this.title = [{
                    id: model.options[0]?.id,
                    label: model.options[0]?.label
                }];
            } else {
                this.title = [];
            }

            this.model = {...this.model, ...(model || {})} || this.model;
            this.openModal = true;
        },
        clear() {
            this.errors = [];
            Object.keys(this.errorFields).forEach(key => {
                this.errorFields[key] = null;
            });
            this.model = {...this.initialModel};
        },
        close(model = null) {
            this.clear();
            this.openModal = false;

            if (model) {
                this.model = model;
            }
        },
        formatDateForDB(date) {
            if (!moment(date, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
                return moment(date, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
            }

            return date;
        },
        setModal(trigger) {
            this.$emit('triggerModal', {trigger: trigger, model: this.model})
        },
        isValidTimeFormat(timeString) {
            const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/;
            return timeFormat.test(timeString);
        }
    },
    mounted() {
        this.model = this.initialModel;

        if (this.values) {
            this.model = {...this.model, ...this.values};
        }
    }
}
</script>
